export default "/static/dashboard/build/app/img/v2/b2b6d877eb2b8528dfeee604ffdcbc63.png";